class VideoSliderManager {
	constructor() {
		this.players = [];
		this.currentlyPlaying = null;
		this.init();
	}

	init() {
		document.querySelectorAll('.video-player').forEach((player, index) => {
			const videoType = player.dataset.videoType;

			if (videoType === 'shopify') {
				this.initShopifyVideo(player);
			} else if (videoType === 'youtube' || videoType === 'vimeo') {
				this.initExternalVideo(player);
			}
		});
	}

	initShopifyVideo(player) {
		const video = player.querySelector('.video-player__video');
		const preview = player.querySelector('.video-player__preview');
		const playBtn = player.querySelector('.video-player__play-btn');
		const pauseBtn = player.querySelector('.video-player__pause-btn');

		if (preview) {
			preview.addEventListener('click', () => {
				video.style.display = 'block';
				requestAnimationFrame(() => {
					this.playVideo(player, video);
				});
			});
		}

		playBtn.addEventListener('click', () => {
			this.playVideo(player, video);
		});

		pauseBtn.addEventListener('click', () => {
			this.pauseVideo(player, video);
		});

		video.addEventListener('click', () => {
			if (video.paused) {
				this.playVideo(player, video);
			} else {
				this.pauseVideo(player, video);
			}
		});

		video.addEventListener('ended', () => {
			this.resetVideo(player, video);
		});
	}

	initExternalVideo(player) {
		const preview = player.querySelector('.video-player__preview');
		const playBtn = player.querySelector('.video-player__play-btn');
		const iframeWrapper = player.querySelector('.video-player__iframe-wrapper');
		const iframe = player.querySelector('[data-video-iframe]');

		const startExternalVideo = () => {
			this.stopAllVideos();

			if (preview) preview.classList.add('hidden');
			if (playBtn) playBtn.style.display = 'none';

			iframeWrapper.style.display = 'block';
			player.classList.add('playing');

			const src = iframe.dataset.src || iframe.src;

			if (!iframe.dataset.src) {
				iframe.dataset.src = src;
			}

			if (src.includes('youtube')) {
				iframe.src = src.includes('autoplay=1')
					? src
					: src + '&autoplay=1';
			} else if (src.includes('vimeo')) {
				iframe.src = src.includes('autoplay=1')
					? src
					: src + '&autoplay=1';
			}

			this.currentlyPlaying = player;
		};

		if (playBtn) {
			playBtn.addEventListener('click', startExternalVideo);
		}

		if (preview) {
			preview.addEventListener('click', startExternalVideo);
		}
	}


	playVideo(player, video) {
		this.stopAllVideos();

		video.muted = false;
		const playPromise = video.play();
		if (playPromise !== undefined) {
			playPromise.catch(() => {
				video.muted = true;
				video.play();
			});
		}

		const preview = player.querySelector('.video-player__preview');
		const playBtn = player.querySelector('.video-player__play-btn');
		const pauseBtn = player.querySelector('.video-player__pause-btn');

		if (preview) preview.classList.add('hidden');
		playBtn.style.display = 'none';
		pauseBtn.style.display = 'flex';
		player.classList.add('playing');

		this.currentlyPlaying = player;
	}

	pauseVideo(player, video) {
		video.pause();

		const playBtn = player.querySelector('.video-player__play-btn');
		const pauseBtn = player.querySelector('.video-player__pause-btn');

		playBtn.style.display = 'flex';
		pauseBtn.style.display = 'none';
		player.classList.remove('playing');
	}

	resetVideo(player, video) {
		video.currentTime = 0;
		video.pause();

		const source = video.querySelector('source');
		if (source) {
			const src = source.src;
			video.removeAttribute('src');
			video.load();
			video.src = src;
			video.load();
		}

		const preview = player.querySelector('.video-player__preview');
		const playBtn = player.querySelector('.video-player__play-btn');
		const pauseBtn = player.querySelector('.video-player__pause-btn');

		if (preview) preview.classList.remove('hidden');
		playBtn.style.display = 'flex';
		pauseBtn.style.display = 'none';
		player.classList.remove('playing');

		this.currentlyPlaying = null;
	}

	stopAllVideos() {
		document.querySelectorAll('.video-player').forEach(player => {
			const video = player.querySelector('.video-player__video');

			if (video) {
				this.resetVideo(player, video);
			} else {
				const preview = player.querySelector('.video-player__preview');
				const playBtn = player.querySelector('.video-player__play-btn');
				const pauseBtn = player.querySelector('.video-player__pause-btn');
				const iframeWrapper = player.querySelector('.video-player__iframe-wrapper');
				const iframe = player.querySelector('[data-video-iframe]');

				if (preview) preview.classList.remove('hidden');
				if (playBtn) playBtn.style.display = 'flex';
				if (pauseBtn) pauseBtn.style.display = 'none';
				if (iframeWrapper) iframeWrapper.style.display = 'none';
				player.classList.remove('playing');

				if (iframe) {
					const src = iframe.src;
					iframe.src = '';
					iframe.src = src.replace('autoplay=1', 'autoplay=0');
				}
			}
		});

		this.currentlyPlaying = null;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	window.videoSliderManager = new VideoSliderManager();
});

class ProductCard extends HTMLElement {
	constructor() {
		super();

		this.form = this.querySelector('[data-card-product-form]');
		this.button = this.querySelector('[data-card-add-to-cart]');
		this.text = this.querySelector('[data-card-add-to-cart-text]');

		if (!this.form || !this.button) return;

		this.isSubmitting = false;
		this.boundSubmit = this.onSubmit.bind(this);
		this.form.addEventListener('submit', this.boundSubmit);
	}

	async onSubmit(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		if (this.isSubmitting || this.button.disabled) {
			return;
		}

		this.isSubmitting = true;
		this.setLoading(true);

		const formData = new FormData(this.form);

		const variantId = formData.get('id');
		const quantity = parseInt(formData.get('quantity')) || 1;

		try {
			document.dispatchEvent(new CustomEvent('product:add', {
				detail: {
					items: [{
						id: variantId,
						quantity: quantity
					}],
					callback: () => {
						this.setLoading(false);
						setTimeout(() => {
							this.isSubmitting = false;
						}, 500);
					},
					errorCallback: (error) => {
						console.error('Error:', error);
						this.setLoading(false);
						this.isSubmitting = false;
					}
				}
			}));

		} catch (error) {
			console.error('Error adding to cart:', error);
			this.setLoading(false);
			this.isSubmitting = false;
		}
	}

	setLoading(state) {
		this.button.disabled = state;
		if (this.text) {
			this.text.innerText = state ? 'Adding…' : 'Add to cart';
		}
	}

	disconnectedCallback() {
		if (this.form && this.boundSubmit) {
			this.form.removeEventListener('submit', this.boundSubmit);
		}
	}
}

if (!customElements.get('product-card')) {
	customElements.define('product-card', ProductCard);
}

document.addEventListener("byob:cart:added", async () => {
	const minicartEl = document.querySelector('#minicart');
	if (!minicartEl) return;
	const vm = minicartEl.__vue__;
	if (!vm) return;

	if (vm.$store) {
		await vm.$store.dispatch('initCart');
		await vm.$nextTick();
	} else {
		await vm.getCart?.();
		await vm.$nextTick();
	}

	document.dispatchEvent(new CustomEvent("open:minicart"));
});